const Space = ({ height }) => {
    return <div style={{
        width: '100%',
        height: height + 'px',
    }}>

    </div>
}
export default Space;